import { ContentBlock } from '@/slices/blog/mocks/articles'

export interface TocItem {
  id: string
  text: string
}

export const generateHeadingId = (text: string): string => text
  .toLowerCase()
  .replace(/[^a-z0-9\s-]/g, '')
  .replace(/\s+/g, '-')

export const extractHeadings = (blocks: ContentBlock[]): TocItem[] => {
  const headings: TocItem[] = []

  blocks.forEach((block) => {
    if (block.type === 'markdown') {
      const matches = block.content.match(/^## (.+)$/gm)

      if (matches) {
        matches.forEach((match) => {
          const text = match.replace(/^## /, '')
          const id = generateHeadingId(text)

          headings.push({ id, text })
        })
      }
    }
  })

  return headings
}
